(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rca-recovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const receivedPanel = document.getElementById('RcaRecoveryReceived');
    receivedPanel?.focus();

    const artifactTitleInput = document.getElementById('RcaArtifactTitle');
    if (artifactTitleInput && !artifactTitleInput.value) {
      const prefill = new URLSearchParams(window.location.search).get('artifact');
      if (prefill) artifactTitleInput.value = prefill;
    }

    const panel = document.getElementById('RcaRecoveryPanel');
    const formWrap = panel?.querySelector('.rca-recovery__form-wrap');
    if (!panel || !formWrap) return;

    const form = formWrap.querySelector('form') || formWrap;
    const fileInput = document.getElementById('RcaEvidence');
    const fileField = document.getElementById('RcaEvidenceField');
    const fileList = document.getElementById('RcaFileList');
    const evidenceError = document.getElementById('RcaEvidenceError');
    const evidenceLinksField = document.getElementById('RcaEvidenceLinksField');
    const evidenceHint = document.getElementById('RcaEvidenceHint');
    const submitButton = document.getElementById('RcaSubmitButton');

    if (!fileInput || !fileField) return;

    const cloudName = panel.dataset.cloudinaryCloudName;
    const uploadPreset = panel.dataset.cloudinaryUploadPreset;
    const isConfigured = Boolean(cloudName) && Boolean(uploadPreset);

    const MAX_FILES = 5;
    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    const ALLOWED_EXTENSIONS = [
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',
      'mp3', 'wav', 'm4a', 'aac', 'ogg',
      'mp4', 'mov', 'webm',
      'pdf', 'doc', 'docx',
    ];

    if (!isConfigured) {
      fileInput.disabled = true;
      if (evidenceHint) evidenceHint.textContent = fileField.dataset.unconfiguredMessage;
      return;
    }

    const isAllowedFile = (file) => {
      if (file.type && /^(image|audio|video)\//.test(file.type)) return true;
      const ext = file.name.split('.').pop().toLowerCase();
      return ALLOWED_EXTENSIONS.includes(ext);
    };

    // Plain substring swap — avoids String.replace()'s special handling of
    // "$"-sequences in the replacement argument, which would otherwise
    // garble the message for a file literally named e.g. "report$&.jpg".
    const withFilename = (template, name) => template.split('%FILENAME%').join(name);

    const showEvidenceError = (message) => {
      evidenceError.textContent = message;
      evidenceError.hidden = false;
    };

    const clearEvidenceError = () => {
      evidenceError.hidden = true;
      evidenceError.textContent = '';
    };

    const validateFiles = (files) => {
      if (files.length > MAX_FILES) {
        showEvidenceError(fileField.dataset.errorCount);
        return false;
      }

      for (const file of files) {
        if (!isAllowedFile(file)) {
          showEvidenceError(withFilename(fileField.dataset.errorType, file.name));
          return false;
        }
        if (file.size > MAX_FILE_SIZE) {
          showEvidenceError(withFilename(fileField.dataset.errorSize, file.name));
          return false;
        }
      }

      return true;
    };

    fileInput.addEventListener('change', () => {
      clearEvidenceError();
      fileList.innerHTML = '';

      const files = Array.from(fileInput.files || []);
      if (!files.length) return;

      if (!validateFiles(files)) {
        fileInput.value = '';
        return;
      }

      files.forEach((file) => {
        const item = document.createElement('li');
        item.textContent = file.name;
        fileList.appendChild(item);
      });
    });

    const uploadToCloudinary = async (file) => {
      const body = new FormData();
      body.append('file', file);
      body.append('upload_preset', uploadPreset);

      const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
        method: 'POST',
        body,
      });

      if (!response.ok) {
        throw new Error(withFilename(fileField.dataset.uploadFailed, file.name));
      }

      const data = await response.json();
      if (!data.secure_url) {
        throw new Error(withFilename(fileField.dataset.uploadFailed, file.name));
      }
      return data.secure_url;
    };

    let isSubmitting = false;
    const submitLabelEl = submitButton?.querySelector('.rca-recovery__submit-label');
    const submitLabelDefault = submitLabelEl?.textContent;

    form.addEventListener('submit', (event) => {
      if (isSubmitting) {
        event.preventDefault();
        return;
      }

      const files = Array.from(fileInput.files || []);

      if (!files.length) {
        // No evidence attached — let the native submit proceed, but still
        // guard against a rapid double-click firing a second submit event
        // before the page navigates away.
        isSubmitting = true;
        if (submitButton) submitButton.disabled = true;
        return;
      }

      event.preventDefault();

      if (!validateFiles(files)) return;

      isSubmitting = true;
      if (submitButton) submitButton.disabled = true;
      if (submitLabelEl) submitLabelEl.textContent = fileField.dataset.uploadingLabel;

      Promise.all(files.map(uploadToCloudinary))
        .then((urls) => {
          evidenceLinksField.value = urls.join('\n');
          form.submit();
        })
        .catch((error) => {
          isSubmitting = false;
          if (submitButton) submitButton.disabled = false;
          if (submitLabelEl) submitLabelEl.textContent = submitLabelDefault;
          showEvidenceError(error.message);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
